export const POST_REVIEW = {
  init: 'reviews/POST_REVIEW/init',
  request: 'reviews/POST_REVIEW/request',
  success: 'reviews/POST_REVIEW/success',
  failure: 'reviews/POST_REVIEW/failure',
} as const;
